export default __webpack_public_path__ + "static/media/GL_atterraggio_375x500.08f92341.mp4";